import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=52491e4c&lang=scss&scoped=true"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52491e4c"]])

export default __exports__